import {CREATE_SIGN_REQUEST} from "../../../enums/Request/request.types";

export const createSignRequestAction = (data) => {
    return {
        type: CREATE_SIGN_REQUEST,
        payload: data,
    };
};
